export default __webpack_public_path__ + "b2d7d8c.png";